<template>
    <div class="stf-divider" :class="{ 'stf-divider--with-text': text, 'stf-divider--stick-bottom': stickBottom }">
        <span v-if="text" class="stf-divider__text">{{ text }}</span>
    </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';

interface Props {
    text?: string;
    stickBottom?: boolean;
}

withDefaults(defineProps<Props>(), {
    stickBottom: false,
});
</script>

<style lang="scss">
@use "bulma/sass/utilities/mixins";
@use '@/assets/sass/_variables' as vars;

.stf-divider {
  height: 1px;
  background-color: vars.$color-gray-200;
  width: 100%;
  margin: 15px 0;
  position: relative;
  border: none;

  @include mixins.mobile {
    margin: 12px 0;
  }

  &--with-text {
    height: auto;
    text-align: center;
    border: none;
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &--stick-bottom {
    margin-bottom: 0;
  }

  &__text {
    display: inline-block;
    padding: 0 16px;
    background: #fff;
    color: vars.$color-gray-600;
    font-size: vars.$font-size-14;
    font-family: vars.$font-family-primary;
    font-weight: vars.$font-weight-medium;
    position: relative;
    z-index: 1;
  }

  &--with-text::before,
  &--with-text::after {
    content: '';
    flex: 1;
    height: 1px;
    background-color: vars.$color-gray-200;
    margin: 0 8px;
  }
}
</style>
